import {Tailwind} from '@wandb/weave/components/Tailwind';
import React from 'react';

import {EventConfigurationProps} from '../TriggerEventConfiguration';

export const RunMetricZscoreSection: React.FC<EventConfigurationProps> = () => {
  return (
    <Tailwind>
      <div>Run metrics z-score threshold met</div>
    </Tailwind>
  );
};
